import paycoUtils from "@/assets/js/utils";
import ProductNotice from "@/domain/product/ProductNotice";


interface IProduct {
  productId: string;
  productImageUrl: string;
  productName: string;
  productIntroText: string;

  salePrice: number;
  listPrice: number;
  discountRate: number;
  discountRateExpsYn?: string;

  productDetailImageUrl?: string;

  brandName?: string;

  informationUseText?: string;
  usableMerchantText?: string;
  unusableMerchantText?: string;
  caution?: string;
  contactUs?: string;
  contactUsTel?: string;

  notices?: Array<ProductNotice>;

  purchasableYn?: string;
  giftableYn?: string;
}

class Product {
  constructor(args: IProduct) {
    return Object.assign(this, args);
  }

  get commaListPrice(): string {
    return paycoUtils.numWithCommas(this.listPrice);
  }

  get commaSalePrice(): string {
    return paycoUtils.numWithCommas(this.salePrice);
  }

  get isDiscounted(): boolean {
    return this.discountRate > 0
  }

  get hasDetailImage(): boolean {
    return !paycoUtils.isEmptyString(this.productDetailImageUrl);
  }

  get isGiftable(): boolean {
    return paycoUtils.convertYnToBoolean(this.giftableYn);
  }

  get isPurchasable(): boolean {
    return paycoUtils.convertYnToBoolean(this.purchasableYn);
  }

  get discountInfoIsExposable(): boolean {
    return paycoUtils.convertYnToBoolean(this.discountRateExpsYn);
  }
}

interface Product extends IProduct {
}

export default Product;